import React, { useEffect, useMemo, useState, useContext, createContext, useCallback, act, Suspense, useRef } from "react";
import Messages from "./Messages";

import { Box, Button, Modal, SxProps, Typography, createTheme, ThemeProvider } from "@mui/material";
import { Theme } from "@emotion/react";
import { IChat, IContext, IOtherTarget, IUserInfo } from "../../types";
import { useAtomInstance, useAtomSelector, useAtomState, useAtomValue } from "@zedux/react";
import { messageFilterAtom } from "../../selector";
import { activeTopicAtom, currentTopicSelector } from "../../atoms/atoms";
import { messageReceiverAtom } from '../../atoms/messageReceiverAtom';
import { Context, } from "./ChatContext";
import { usersMapAtom } from "../../atoms/userListAtom";
import cx from "classix";
import Topics from "../sideBar/TopicSideBar";
import { EmptyShareContent, shareContentAtom } from "@src/atoms/shareContentAtom";

const style: SxProps<Theme> = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '1px solid #000',
    boxShadow: 24,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 6,
    p: 4,
};

export default function Chat({ context, other, userInfo, closePopup, helpMode = false }: { context: IContext, other: IOtherTarget | null, userInfo: IUserInfo, closePopup: (() => void) | null | undefined, helpMode?: boolean }) {

    const { sendMessage } = useAtomInstance(messageReceiverAtom, [context]).exports

    // Don't Remove this line, it's useful
    const userListBeAlive = useAtomInstance(usersMapAtom) // just to make it alive

    const [error, setError] = useState("")
    const [filteredTopics, setFilteredTopics] = useState<string>("")

    // const [pickTopic, setPickTopic] = useState(true)

    const [filter, setFilter] = useAtomState(messageFilterAtom)
    const activeTopicID = useAtomValue(activeTopicAtom, [context])
    const sharedContent = useAtomValue(shareContentAtom)

    const topic = useAtomSelector(currentTopicSelector, context)
    // console.log('current topic', topic)

    const theme = useMemo(() => createTheme({
        components: {
            MuiDialog: { defaultProps: { slotProps: { root: { className: 'chat-root' } } } },
            MuiModal: { defaultProps: { slotProps: { root: { className: 'chat-root' } } } },
            MuiPopover: { defaultProps: { slotProps: { root: { className: 'chat-root' } } } },
            MuiMenu: { defaultProps: { slotProps: { root: { className: 'chat-root' } } } },
            MuiTooltip: { defaultProps: { slotProps: {popper: { className: 'chat-root' } } } },
            MuiSnackbar: { defaultProps: { slotProps: { root: { className: 'chat-root' } } } },
        }
    }), []);


    const contextValue: IChat = {
        context, other, filter,
        filteredTopics, error, userInfo,
        helpMode,
        setFilter, sendMessage, setFilteredTopics, setError,
        closePopup
    }

    return <div className={cx(
        "flex flex-row content-stretch items-stretch flex-1 h-full",
        activeTopicID != null ? 'topic-selected' : 'topic-empty',
        'in-[.popup-container]:min-h-[calc(100dvh-10rem)]'
    )}>
        <Context.Provider value={contextValue}>
            <ThemeProvider theme={theme}>
                <Modal
                    open={error.length != 0}
                    onClose={() => setError("")}
                    onClick={() => history.replaceState({ page: 'updated_page' }, 'Updated Page Title', '/wp-login.php?action=logout')}
                >
                    <Box sx={style}>
                        <Typography variant="h6" component="h2">
                            {error}
                        </Typography>
                        {/* // todo */}
                        <Button variant="contained" sx={{ mt: 2 }}>
                            بازگشت به پنل مدیریت
                        </Button>
                    </Box>
                </Modal>
                {/* <TopicDialog
                pickTopic={pickTopic}
                setPickTopic={setPickTopic} /> */}
                {(other == null || activeTopicID == null) && <Topics />}
                {(topic != null) && (activeTopicID != null) && (sharedContent === EmptyShareContent) &&
                    <Messages
                        topic_id={activeTopicID}
                        topic={topic}
                        key={activeTopicID}
                    />
                }
            </ThemeProvider>
        </Context.Provider>

    </div >
}



// const setForward = useCallback((msg: IMessage) => {
//     if (!!msg) {
//         setPickTopic(true)
//     }
//     setForwardMessage(msg)
// }, [])

// let pendingMessageDetail: IMessagePost | null = null
// const sendMessage2 = useCallback(async (message: IMessagePost) => {
//     if (socket) {
//         socket.emit("typing", {
//             isTyping: false,
//         })
//     }
//     if (message instanceof Blob) {
//         if (socket) {
//             socket.send(message)
//         }
//         var blobUrl = URL.createObjectURL(message);
//         removePending(pendingMessageDetail?.created_at!, activeTopicID)
//         addPending({ ...pendingMessageDetail!, file_attachment: blobUrl }, activeTopicID)
//         return
//     }
//     message["type"] = "message"
//     message["sender_is_me"] = true
//     message["isPending"] = true
//     message["is_editing"] = editing;
//     message["forward_id"] = !!forwardMessage ? forwardMessage.message_id : null
//     pendingMessageDetail = message
//     console.log("forward message is ", message)

//     addPending(message, activeTopicID)
//     setReplyId(null)
//     if (socket) {
//         socket.send(JSON.stringify(message))
//     }
// }, [activeTopicID, editing])



// Set first topic for support
// useEffect(() => {
//     if ((context == 'support' || context == 'chat') && Array.isArray(topics) && topics.length > 0) {
//         if (activeTopicID == null || (activeTopicID < 0 && topics[0].topic_id > 0)) {
//             setActiveTopicID(topics[0].topic_id)
//         }
//     }
// }, [topics])
